import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "15% manj",
  "description": "",
  "published": "2006-11-12T00:00:00.000Z",
  "redirect_from": ["/blog/15-manj/swizec/359"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Ljudje so zmesani, ampak ne mislim na obicajen misantropicen nacin `}{`_`}{`ljudje so zmesani, `}{`_`}{`mislim resno, kot zivalska vrsta, so ljudje preprosto zmesani. Samo poglejte kaj se zgodi, ko neka velka korporacija podari 15% popust na vse izdelke na neko doloceno nedeljo, ki je slucajno danes. Vrste so bile daljse, kot sem jih videl kdajkoli v zivljenju, kaj sele na nedeljo. Skoraj se ni bilo nikjer premikati in mislil sem ze, da sem zasel v kolonijo mrozev na soncarskem izletu. Zmesano.`}</p>
    <p>{`Hm, kaj se je se zgodilo danes, aja saj res. Odkril sem odlicen nacin za odlaganje pisanja, zanimivo je koliko se povprecen pisatelj v bistvu potrudi samo, da bi se izognil strasnemu sindormu prazne strani. Ok, je res, moje strani niso vec ravno prazne, pa tudi idej ni manjkalo, ampak nekaj najbolj groznega je, ko se vsedes in se lotis pisati. Zato sem danes porabil veliko ur in koncno naredil namizje lepo in nasploh odlicno okolje za delo.`}</p>
    <p>{`Ce ga res zelite videti, ga lahko `}<a parentName="p" {...{
        "href": "http://swizec.com/MyScreenie.png"
      }}>{`tu`}</a>{`, vendar je zelo zelo velika slika.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      